import React, {useEffect, useState} from 'react';
import { Container} from "@mui/material";
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import CustomInput from "../components/CustomInput/CustomInput";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LockOutlined as LockOutlinedIcon } from '@mui/icons-material';
import './Login.css'
import IconoGoogle from "../../images/google-icon.png";
import IconoFacebook from "../../images/facebook-logo.png";
import { useLocation } from 'react-router-dom';
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import LoadingButton from "../components/LoadingButton/LoadingButton";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../context/urls'
import { LOGIN_TEXTS } from './loginTexts';


function Login() {
    const location = useLocation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [cargando, setCargando] = useState(false);

    useEffect(() => {
        // Verifica si venimos de una redirección con estado registrado
        if (location.state?.registered) {
            toast.success(LOGIN_TEXTS.TOAST_MESSAGES.REGISTER_SUCCESS, {
                position: "top-center",
                autoClose: 15000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        if (location.state?.changedPassword) {
            toast.success(LOGIN_TEXTS.TOAST_MESSAGES.PASSWORD_CHANGED, {
                position: "top-center",
                autoClose: 15000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }, [location]);

    const sendAPIRequestRegister = (dataToSend) => {
        return axios.post(URLS.API_LOGIN, dataToSend, {
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.error('Error al realizar la solicitud:', error);
                throw error;
            });
    };

    function handleSubmit() {
        setCargando(true);

        const dataToSend = {
            email: email,
            password: password,
        };

        sendAPIRequestRegister(dataToSend)
            .then((response) => {
                navigate('/crear-casillero-2');
            })
            .catch((error) => {
                console.error('Error al realizar la solicitud:', error);
                Object.keys(error.response.data).forEach((key) => {
                    // Para cada clave, iterar sobre el array de mensajes de error
                    toast.error(`${error.response.data.detail}`, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                });
            })
            .finally(() => {
                setCargando(false);
            });
    }

    return (
        <>
            <Container maxWidth="xl">
                <ToastContainer />
                <h2 className="login-title">{LOGIN_TEXTS.MAIN_TITLE}</h2>

                <CustomInput
                    additionalClassName="input-login"
                    placeholder="Correo electrónico"
                    type="text"
                    startIcon={<PermIdentityOutlinedIcon />}
                    hideValidation= {true}
                    setValue={setEmail}
                />
                <CustomInput
                    additionalClassName="input-login"
                    placeholder="Contraseña"
                    type="password"
                    startIcon={<LockOutlinedIcon />}
                    showPasswordIcon={<Visibility />}
                    hidePasswordIcon={<VisibilityOff />}
                    hideValidation= {true}
                    setValue={setPassword}
                />
                <div className="loading-button">
                <LoadingButton
                    handleSubmit={handleSubmit}
                    loading={cargando}
                    label={LOGIN_TEXTS.LOGIN_BUTTON_LABEL}
                    customStyles={{
                        height: {xs: "8vw", sm: "2.3vw"},
                        width: {xs: "75%", sm: "100%"},
                        fontSize: {xs: "3.7vw", sm: "1.2vw"},
                        marginTop: {xs: "4vw", sm: "2vw"}, 

                    }
                    }
                />
                </div>
                {/* Texto Inferior*/}
                <div className="texto-inferior-login">
                    <div>
                        <a  className="forgot-password" href="/recuperar-contrasena">
                            {LOGIN_TEXTS.FORGOT_PASSWORD_TEXT}
                        </a>
                    </div>
                    <br></br>
                    
                    <div>
                        <span className="login-undertext">
                        {LOGIN_TEXTS.REGISTER_PROMPT}<a href="/crear-casillero">{LOGIN_TEXTS.REGISTER_LINK_TEXT}</a>
                        </span>
                    </div>
                </div>
            </Container>
        </>
    );
}

export default Login;
